import { InitialTheme, Theme } from '../types';

export const hexToRGB = (h: string) => {
  let r = '0';
  let g = '0';
  let b = '0';

  // 3 digits
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;

    // 6 digits
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }

  return [+r, +g, +b].join(', ');
};

export const remToPx = (rem: string) => {
  const baseFontSize = getComputedStyle(document.documentElement).fontSize;
  return parseFloat(rem) * parseFloat(baseFontSize);
};

export const createTheme = (initialTheme: InitialTheme): Theme => ({
  ...initialTheme,
  breakPoints: {
    ...initialTheme.breakPoints,
    down: (key) => `@media (max-width: ${initialTheme.breakPoints.values[key]}) `,
    up: (key) => `@media (width > ${initialTheme.breakPoints.values[key]}) `,
    between: (start, end) =>
      `@media (min-width:${initialTheme.breakPoints.values[start]}) and (max-width:${initialTheme.breakPoints.values[end]}) `,
  },
  spacing: {
    ...initialTheme.spacing,
    calc: (value) => `calc(${initialTheme.spacing.primary} * ${value})`,
  },
});
